import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import Loading from './Loading';
import CoinId from './CoinId.json';
var numeral = require('numeral');
var cryptocurrencies = require('cryptocurrencies');

 
class EventModal extends Component {
 
componentDidMount(){
    this._isMounted = true;
    this.getLogo();
    this.getNews(); 
    
    }
       
componentWillUnmount(){
  this._isMounted = false;
}

async getLogo(){
  //let x =  cryptocurrencies[this.props.coinName]
  //let x = CoinId.filter(coin => coin.name === this.props.coinName)
  let ID = CoinId.filter(coin => coin.name === this.props.coinName)
  let x = ID[0].ID

  if(x !== undefined)
  fetch('https://api.coingecko.com/api/v3/coins/'+x+'?tickers=false&market_data=false&community_data=false&developer_data=false&sparkline=false')
  .then(res => res.json())
  .then((data) => {
    if (this._isMounted && data !== undefined){
    this.setState({logo: data.image.small })}
  })
  .catch(console.log)
}


getNews = ()=>{

  let ID = CoinId.filter(coin => coin.name === this.props.coinName)
  let x = ID[0].ID
    
    var request = require("request"); 
    if(x !== undefined){
    var options = { method: 'GET',
    url: 'https://cors-anywhere.herokuapp.com/https://developers.coinmarketcal.com/v1/events',

     //url: 'https://thingproxy.freeboard.io/fetch/https://developers.coinmarketcal.com/v1/events',
     qs: { max: '10', coins: x},
     headers: 
      { Accept: 'application/json',
        'Accept-Encoding': 'deflate, gzip',
        'x-api-key': 'xjR9ooNffv1X72pJdilty4PdJnlAhTY5LAewxuY4' } };
   
    request(options, function (error, response, body) {
     if (error) throw new Error(error);
    
     if(JSON.parse(body).body !== undefined){
         this.setState({news:JSON.parse(body).body,loading:false})
     }
   }.bind(this));
  }  
  setTimeout(()=>this.setState({loading:false}),1000)

}


constructor(props,context){
    super(props)
    this.state = {

        summaryModalShow: false,
        hide:this.props.onHide,
        loading:true,
        news:null,
        logo:[],
        
        
    }

  }



    render(){
      let m =  cryptocurrencies[this.props.coinName]
        let news =  ''
        if(this.state.loading){
            news = <div style ={{textAlign:"center"}}>
             
            <h1 className="spin mt-5 large"><i class="fas fa-yin-yang"></i></h1>
            
        </div>
        }
        if(this.state.news !== null && !this.state.loading){
           
            news = this.state.news.map((news,index)=>(
                <div className="news" key={index}>
                  <div>
                    <img src={this.state.logo} className="logo"/>
                  </div>
                   {news.coins[0].fullname}
                <div> 
                <a href={news.source} target="blank" className="links"> 
                {news.title.en}
                </a>
                </div>
                {news.date_event.slice(0,10)}
                <img src={news.proof} className="newsImage"/>
                </div>
                        ))}
                        
                        else if(this.state.news == null && !this.state.loading){
                            news = <div className="news"><div>
                                    <img src={this.state.logo} className="logo"/>
                              </div> No Upcoming News
                              </div>
                        }
       
    return( 
      
      <Modal
        {...this.props}
        size="md"
        height="200px"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
        
      <Modal.Header className="modalpie" closeButton>
      <Modal.Title id="contained-modal-title-vcenter">
        <div className="banana3">News for the Next 7 Days</div>
      </Modal.Title>
      </Modal.Header> 
        
      <Modal.Body> 
        {news}
        <button  className="cancel" title="Cancel" onClick={this.props.onHide}>Close</button>
      </Modal.Body>
            
      

      </Modal>
      )
    }

}

export default EventModal;